import React from 'react';
import { useInView } from '../hooks/useInView';

const SkillTag = ({ skill }) => {
    const { ref, inView } = useInView();

    return (
        <a
            ref={ref}
            className={`skills-clickable group-skill-clickable fade-in-up hover-lift-sm ${inView ? 'animation-active' : ''}`}
            href={skill.url}
            target='_blank'
            rel="noreferrer">
            {skill.name}
        </a>
    );
};

export default SkillTag;
